export default __webpack_public_path__ + "static/media/mario.010448c6.png";